// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"K8-z"};